var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"job_listing"}},[_c('div',{staticClass:"header"},[_c('JobListingHeader')],1),_c('div',{staticClass:"body my-10"},[_c('ListingTHead'),_c('ListingTBody')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }